import _ from 'underscore';
import React, {
  FC, memo, useContext, useMemo,
} from 'react';
import { ArrowLeft16Regular } from '@fluentui/react-icons';
import { I18nContext, I18nModel } from '@bingads-webui/copilot-i18n';
import { Button } from '@fluentui/react-components';
import { ConversationListProps } from '../../types';
import { useConversationsListStyles } from './use-conversations-list-styles';

export const ConversationsList: FC<ConversationListProps> = memo((props) => {
  const { conversationsList: propConversationsList, onClose, onResetConversation } = props;
  const styles = useConversationsListStyles();
  const i18n = useContext(I18nContext) as I18nModel;

  const conversationsList = useMemo(() => {
    let existingConversations: ConversationListProps['conversationsList'] = [];
    const sessionData = sessionStorage.getItem('conversationData');

    try {
      if (sessionData) {
        existingConversations = JSON.parse(sessionData);
        if (!_.isArray(existingConversations)) {
          throw new Error('Invalid conversation data format in session storage.');
        }
      }
    } catch (error) {
      existingConversations = [];
    }
    return propConversationsList || existingConversations || [];
  }, [propConversationsList]);

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Button icon={<ArrowLeft16Regular />} onClick={onClose} appearance="subtle" />
        <span className={styles.title}>{i18n.getString(_TL_('Chat History'))}</span>
      </div>
      {conversationsList?.map(({ id, title, date }) => (
        <Button
          key={id}
          className={styles.button}
          onClick={() => onResetConversation?.(id)}
        >
          <span>{title || i18n.getString(_TL_('Untitled'))}</span>
          <span className={styles.date}>{new Date(date).toLocaleString()}</span>
        </Button>
      ))}
    </div>
  );
});
